import { combineReducers } from 'redux';
import { bookingReducer } from './dialogState/Reducer';
import { googleGeoCoderReducer } from './googleGeoCoder/Reducer';
import { submitStateReducer } from './submitState/Reducer';
import { baggageInfoReducer } from './baggageinfo/Reducer';
import { bookapiInsurancesReducer } from './bookapiInsurances/Reducer';
import { bookapiPaymentsReducer } from './bookapiPayments/Reducer';
import { bookapiFlexRateReducer } from './bookapiFlexRate/Reducer';
import { bookapiRoomCateringUpsellingRateReducer } from './bookapiRoomCateringUpselling/Reducer';
import { bookapiTrainRatesReducer } from './bookapiTrainRates/Reducer';
import { bookapiTransferOffersReducer } from './bookapiTransferOffers/Reducer';
export var bookingRootReducer = combineReducers({
    dialogState: bookingReducer,
    googleGeoCoderState: googleGeoCoderReducer,
    submitState: submitStateReducer,
    baggageInfoState: baggageInfoReducer,
    bookapiFlexRateState: bookapiFlexRateReducer,
    bookapiRoomCateringUpsellingRateState: bookapiRoomCateringUpsellingRateReducer,
    bookapiInsurancesState: bookapiInsurancesReducer,
    bookapiPaymentsState: bookapiPaymentsReducer,
    bookapiTrainRatesState: bookapiTrainRatesReducer,
    bookapiTransferOffersState: bookapiTransferOffersReducer
});
export default bookingRootReducer;
